import { Children, isValidElement, ReactNode } from 'react';

export function getChildrenDeep<
  TChildren extends ReactNode,
  TOutput = ReactNode
>(children: TChildren, predicate: (item: TOutput) => boolean): TOutput[] {
  const _children = Children.toArray(children);
  let out: TOutput[] = [];

  for (const child of _children) {
    if (predicate(child as TOutput)) {
      out = [...out, child as TOutput];
    }

    if (isValidElement(child) && child.props?.children) {
      out = [
        ...out,
        ...getChildrenDeep<TChildren, TOutput>(child.props.children, predicate),
      ];
    }
  }
  return out;
}
